module.exports = __webpack_public_path__ + "static/media/no_internet_icon.06da96e5.svg";